import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import ChartDataLabels from "chartjs-plugin-datalabels";

const DonationsChart = (props) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (props.cycleSummary && props.cycleSummary.length > 0) {
      const labels = props.cycleSummary.map((c) => c.cycleName);
      const donations = props.cycleSummary.map((c) => c.totalDonations || 0);
      const bags = props.cycleSummary.map((c) => c.bagsDistributed || 0);

      setChartData({
        labels: labels,
        datasets: [
          {
            label: "Total Donations",
            backgroundColor: "#0095FF",
            data: donations,
            yAxisID: "y",
          },
          {
            label: "Bags Distributed",
            backgroundColor: "#00D4C6",
            data: bags,
            yAxisID: "y1",
          },
        ],
      });
    }
  }, [props.cycleSummary]);

  const options = {
    maintainAspectRatio: false,
    aspectRatio: 0.7,
    plugins: {
      datalabels: {
        color: "#f3f6f4",
        font: {
          size: "12px",
          weight: "600",
        },
        display: function (context) {
          return context.dataset.data[context.dataIndex] > 0;
        },
        formatter: function (value, context) {
          if (context.dataset.yAxisID === "y") {
            return value >= 1000 ? (value / 1000).toFixed(0) + "k" : value;
          }
          return value;
        },
      },
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#495057",
        },
      },
    },
    scales: {
      x: {
        ticks: { color: "#495057", font: { size: 11 } },
        grid: { color: "#e6e6e6" },
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
          text: "Donations (Rs)",
          color: "#0095FF",
          font: { size: 11, weight: "bold" },
        },
        ticks: { color: "#495057" },
        grid: { color: "#e6e6e6" },
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        title: {
          display: true,
          text: "Bags",
          color: "#00D4C6",
          font: { size: 11, weight: "bold" },
        },
        ticks: { color: "#495057" },
        grid: { drawOnChartArea: false },
      },
    },
  };

  return (
    <div className="layout-main-height">
      <div className="datatable-doc-demo">
        <div className="card-1">
          <Chart
            type="bar"
            data={chartData}
            options={options}
            plugins={[ChartDataLabels]}
          />
        </div>
      </div>
    </div>
  );
};

export default DonationsChart;
